import { ConfigService } from './config.service';
import { Cuenta } from '../models/cuenta';
import { CuentaDistribuidor } from '../models/cuentaDistribuidor';
import { DatePipe } from '@angular/common'
import { Direccion } from '../models/direccion';
import { Injectable } from '@angular/core';
import { ItemParametro } from '../models/itemparametro';
import { ListaPrecioCabecera } from '../models/listaPrecioCabecera';
import { ListaPrecioItem } from '../models/listaPrecioItem';
import { ReplaceDecimal } from '../utils/decimal.pipe'
import { ReporteExcelUsuarios } from '../models/reporteExcelUsuarios';
import { Workbook } from 'exceljs/dist/exceljs.min.js';
import * as fs from 'file-saver';
import { PedidoCabecera } from '../models/pedidoCabecera';
import { Distribuidor } from '../models/distribuidor';
import { PedidoDetallado } from '../models/pedidoDetallado';
import { Stock } from '../models/stock';
import { StockDistribuidores } from '../models/stockDistribuidores';
import { StockDistribuidoresLotes } from '../models/stockDistribuidoresLotes';
import { ShipToDistribuidor } from '../models/shipToDistribuidor';


@Injectable({
  providedIn: 'root'
})
export class ExcelService {


  constructor(private configService: ConfigService, private replaceDecimal: ReplaceDecimal, private datepipe: DatePipe) { }

  //ADM
  cExcelReporteItemsParametros(itemsParametros: ItemParametro[]) {
    let ips: ItemParametro[] = [];
    ips = Object.assign([], itemsParametros);
    ips = ips.sort((a, b) => a.descripcionParametro.localeCompare(b.descripcionParametro));
    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.ItemsParametros.ExcelAltaMasiva.P1);

    workSheet1 = this.cWorksheetReporteItemsParametros(workSheet1);

    workSheet1 = this.cDataWorkSheetItemsParametros(ips, workSheet1);

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, this.configService.etiquetas.ItemsParametros.NombreExcelReporte + '.xlsx');
    })
  }
  cWorksheetReporteItemsParametros(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4


    workSheet.columns = [
      { header: this.configService.etiquetas.ItemsParametros.ExcelAltaMasiva.Headers.IdParametro, key: 'idParametro', width: 25 },
      { header: this.configService.etiquetas.ItemsParametros.ExcelAltaMasiva.Headers.DescripcionParametro, key: 'descripcionParametro', width: 25 },
      { header: this.configService.etiquetas.ItemsParametros.ExcelAltaMasiva.Headers.IdItem, key: 'idItem', width: 20 },
      { header: this.configService.etiquetas.ItemsParametros.ExcelAltaMasiva.Headers.DescripcionItem, key: 'descripcionItem', width: 40 },
      { header: this.configService.etiquetas.ItemsParametros.ExcelAltaMasiva.Headers.Habilitacion, key: 'habilitacion', width: 25 },
    ];


    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    return workSheet;
  }
  cDataWorkSheetItemsParametros(itemsParametros: ItemParametro[], workSheet: any) {

    if (itemsParametros.length) {
      itemsParametros.forEach(c => {
        let row = workSheet.addRow(
          {
            idParametro: c.idParametro,
            descripcionParametro: c.descripcionParametro,
            idItem: c.idItem,
            descripcionItem: c.descripcion,
            habilitacion: c.habilitacion ? "Si" : "No"
          }
        )

      });
    }

    return workSheet;
  }

  cExcelReporteUsuarios(reporte: ReporteExcelUsuarios) {

    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.Usuarios.ExcelReporte.P1);
    workSheet1 = this.cWorksheetReporteUsuarios(workSheet1);
    workSheet1 = this.cDataWorkSheetReporteUsuarios(reporte, workSheet1);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, "Reporte Usuarios" + '.xlsx');
    })


  }

  cWorksheetReporteUsuarios(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4

    workSheet.autoFilter = 'A1:N1';
    workSheet.columns = [
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.Email, key: 'email', width: 40 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.Nombre, key: 'nombre', width: 25 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.Apellido, key: 'apellido', width: 25 },
      { header: this.configService.etiquetas.Usuarios.Headers.Rol, key: 'rolName', width: 25 },
      { header: this.configService.etiquetas.Habilitacion, key: 'habilitacion', width: 20 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.RecibeMailAutorizacion, key: 'recibeMailAutorizacion', width: 25 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.EmailConfirmado, key: 'emailConfirmado', width: 25 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.PrimerInicioSesion, key: 'primerInicioSesion', width: 35 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.FechaPrimerInicioSesion, key: 'fechaPrimerInicioSesion', width: 35 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.IntentosFallidos, key: 'intentosFallidos', width: 25 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.UltimoInicioSesion, key: 'ultimoInicioSesion', width: 35 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.UltimoCambioClave, key: 'ultimoCambioClave', width: 35 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.Bloqueado, key: 'bloqueado', width: 20 },
      { header: this.configService.etiquetas.Usuarios.ExcelReporte.Headers.FechaFinBloqueo, key: 'fechaFinbloqueo', width: 35 },

    ];


    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })

    return workSheet;
  }

  cDataWorkSheetReporteUsuarios(reporte: ReporteExcelUsuarios, workSheet: any) {

    if (reporte.usuarios.length) {
      reporte.usuarios.forEach(u => {

        let row = workSheet.addRow(
          {
            email: u.email,
            nombre: u.nombre,
            apellido: u.apellido,
            rolName: u.rol.name,
            habilitacion: u.habilitacion ? "Si" : "No",
            emailConfirmado: u.emailConfirmado ? "Si" : "No",
            recibeMailAutorizacion: u.recibeMailAutorizacion ? "Si" : "No",
            primerInicioSesion: u.firstLogin ? "Si" : "No",
            fechaPrimerInicioSesion: u.firstLoginDate,
            intentosFallidos: u.accessFailedCount,
            ultimoInicioSesion: u.lastLoginTime,
            ultimoCambioClave: u.lastPasswordChangedDate,
            bloqueado: u.bloqueado ? "Si" : "No",
            fechaFinbloqueo: u.lockoutEnd
          }
        )


      });
    }
    return workSheet;

  }

  cExcelListaPrecioItems(items: ListaPrecioItem[], cabecera: ListaPrecioCabecera) {
    let i: ListaPrecioItem[] = [];
    i = Object.assign([], items);
    i = i.sort((a, b) => a.descripcion.localeCompare(b.descripcion));

    let workbook = new Workbook();
    workbook.creator = 'Order2Go CL';
    let workSheet1 = workbook.addWorksheet('Ítems');
    workSheet1 = this.cWorkSheetListaPrecioItems(workSheet1);
    workSheet1 = this.cDataWorkSheetListaPrecioItems(i, cabecera, workSheet1)

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, "Lista Precio " + cabecera.descripcion + '.xlsx');
    })
  }

  cWorkSheetListaPrecioItems(workSheet: any) {

    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    //workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4

    workSheet.columns = [
      { header: this.configService.etiquetas.Codigo, key: 'id', width: 20 },
      { header: this.configService.etiquetas.Descripcion, key: 'descripcion', width: 25 },
      { header: 'Id Lista Precio', key: 'idListaPrecio', width: 20 },
      { header: 'Lista Precio', key: 'listaPrecio', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Cabeceras.TerminoPago, key: 'terminoPago', width: 30 },
      { header: this.configService.etiquetas.ListasPrecios.Cabeceras.FormaPago, key: 'formaPago', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Items.Moneda, key: 'idMoneda', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Items.Tasa, key: 'tasa', width: 25 },
      { header: this.configService.etiquetas.ListasPrecios.Items.IdUnidadMedidaBase, key: 'idUnidadMedidaBase', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Items.LineaProducto, key: 'lineaProducto', width: 30 },
      { header: this.configService.etiquetas.ListasPrecios.Cabeceras.FechaValidaDesde, key: 'fechaValidaDesde', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Cabeceras.FechaValidaHasta, key: 'fechaValidaHasta', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Cabeceras.DescuentoDiscrecional, key: 'descuentoDiscrecional', width: 20 },
      { header: this.configService.etiquetas.ListasPrecios.Cabeceras.PrecioFijo, key: 'precioFijo', width: 20 },

    ];

    workSheet.getColumn("tasa").numFmt = '#,##0.000'

    workSheet.autoFilter = 'A1:N1';

    let headerRow2 = workSheet.getRow(1);
    headerRow2.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })

    return workSheet;
  }

  cDataWorkSheetListaPrecioItems(items: ListaPrecioItem[], cabecera: ListaPrecioCabecera, workSheet: any) {

    if (items.length) {
      items.forEach(c => {
        let row = workSheet.addRow(
          {
            id: c.idProducto,
            descripcion: c.descripcion,
            idListaPrecio: c.idTipoListaPrecios,
            listaPrecio: cabecera.descripcion,
            terminoPago: c.terminoPago,
            formaPago: cabecera.formaPago,
            idMoneda: c.idMoneda,
            tasa: c.tasa,
            idUnidadMedidaBase: c.idUnidadMedidaBase,
            lineaProducto: c.lineaProducto,
            fechaValidaDesde: c.sFechaValidaDesde,
            fechaValidaHasta: c.sFechaValidaHasta,
            descuentoDiscrecional: cabecera.descuentoDiscrecional ? "Si" : "No",
            precioFijo: cabecera.precioFijo ? "Si" : "No",


          }
        )
        row.eachCell(function (cell, colNumber) {
          if (cell.value)
            row.getCell(colNumber).font = { color: { argb: "10384f" } };
        });

      });
    }
    return workSheet;
  }

  //Cuentas

  cExcelCuentas(cuentas: Cuenta[], cuentasDistribuidores: CuentaDistribuidor[], direcciones: Direccion[]) {
    let c: Cuenta[] = [];
    c = Object.assign([], cuentas);
    c = c.sort((a, b) => a.nroCliente.localeCompare(b.nroCliente));

    let cd: CuentaDistribuidor[] = [];
    cd = Object.assign([], cuentasDistribuidores);

    let d: Direccion[] = [];
    d = Object.assign([], direcciones);

    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet("Cuentas");
    workSheet1 = this.cWorksheetCuentas(workSheet1);
    workSheet1 = this.cDataWorkSheetCuentas(c, workSheet1);

    let workSheet2 = workbook.addWorksheet("Distribuidores");
    workSheet2 = this.cWorksheetCuentasDistribuidores(workSheet2);
    workSheet2 = this.cDataWorkSheetCuentasDistribuidores(cd, workSheet2);

    let workSheet3 = workbook.addWorksheet("Direcciones");
    workSheet3 = this.cWorksheetDirecciones(workSheet3);
    workSheet3 = this.cDataWorkSheetDirecciones(d, workSheet3);

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, "Cuentas" + '.xlsx');
    })
  }

  cWorksheetCuentas(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4


    workSheet.columns = [
      { header: this.configService.etiquetas.Cuentas.NroCliente, key: 'nroCliente', width: 25 },
      { header: this.configService.etiquetas.Cuentas.Nombre, key: 'nombre', width: 35 },
      { header: this.configService.etiquetas.Cuentas.Cuit, key: 'cuit', width: 25 },
      { header: this.configService.etiquetas.Cuentas.IdCondicionPago, key: 'condicionPago', width: 40 },
      { header: this.configService.etiquetas.Cuentas.IdRegion, key: 'region', width: 25 },
      { header: this.configService.etiquetas.IdTaxClassification, key: 'taxClassification', width: 25 },
      { header: this.configService.etiquetas.Cuentas.IdGrupoCliente, key: 'grupoCliente', width: 25 },
      { header: this.configService.etiquetas.Cuentas.IdDivision, key: 'idDivision', width: 25 },
      { header: this.configService.etiquetas.Cuentas.CodigoPostal, key: 'codigoPostal', width: 25 },
      { header: this.configService.etiquetas.Cuentas.Ciudad, key: 'ciudad', width: 25 },
      { header: this.configService.etiquetas.Cuentas.CalleNro, key: 'calleNro', width: 35 },
      { header: this.configService.etiquetas.Cuentas.IdZonaVendedor, key: 'zonaVendedor', width: 25 },
      { header: this.configService.etiquetas.Cuentas.IdTipoCredito, key: 'tipoCredito', width: 25 },
      { header: this.configService.etiquetas.Cuentas.LimiteCredito, key: 'limiteCredito', width: 25 },
      { header: this.configService.etiquetas.Cuentas.CreditoUtilizado, key: 'creditoUtilizado', width: 25 },
      { header: this.configService.etiquetas.Cuentas.FechaVtoCredito, key: 'fechaVtoCredito', width: 25 },
      { header: this.configService.etiquetas.Cuentas.IdMoneda, key: 'idMoneda', width: 25 },
      { header: this.configService.etiquetas.Cuentas.Status, key: 'status', width: 10 },
      { header: "Desc. status", key: 'mensajeStatus', width: 45 },
      { header: "Bloqueo", key: 'mensajeBloqueo', width: 45 },

    ];
    workSheet.autoFilter = 'A1:T1';

    //workSheet.getColumn('fechaVtoCredito').numFmt = 'dd/mm/yyyy';
    workSheet.getColumn("limiteCredito").numFmt = '#,##0.00'
    workSheet.getColumn("creditoUtilizado").numFmt = '#,##0.00'


    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    return workSheet;
  }

  cDataWorkSheetCuentas(cuentas: Cuenta[], workSheet: any) {

    if (cuentas.length) {
      cuentas.forEach(c => {
        let row = workSheet.addRow(
          {
            nroCliente: c.nroCliente,
            nombre: c.nombre,
            cuit: c.cuit,
            condicionPago: c.condicionPago,
            taxClassification: c.taxClassification,
            grupoCliente: c.grupoCliente,
            idDivision: c.idDivision,
            codigoPostal: c.codigoPostal,
            ciudad: c.ciudad,
            calleNro: c.calleNro,
            zonaVendedor: c.zonaVendedor,
            tipoCredito: c.tipoCredito,
            region: c.region,
            limiteCredito: c.limiteCredito,
            creditoUtilizado: c.creditoUtilizado,
            fechaVtoCredito: c.fechaVtoCredito != "0000-00-00" ? c.fechaVtoCredito : "",
            idMoneda: c.idMoneda,
            status: c.status,
            mensajeBloqueo: c.mensajeBloqueo != null ? c.mensajeBloqueo : "",
            mensajeStatus: c.status == "A" ? "Cuenta activa" : c.mensajeStatus
          }
        )


        let condicionPago = row.getCell('condicionPago');
        condicionPago.alignment = { wrapText: true }

        let nombre = row.getCell('nombre');
        nombre.alignment = { wrapText: true }

        let ciudad = row.getCell('ciudad');
        ciudad.alignment = { wrapText: true }

        let calleNro = row.getCell('calleNro');
        calleNro.alignment = { wrapText: true }

        let mensajeBloqueo = row.getCell('mensajeBloqueo');
        mensajeBloqueo.alignment = { wrapText: true }

        let mensajeStatus = row.getCell('mensajeStatus');
        mensajeStatus.alignment = { wrapText: true }


        let clase = row.getCell("status");

        clase.font = {
          bold: true,
          color: { argb: c.status == 'A' ? '108000' : 'B80239' }
        }
        clase.alignment = { vertical: 'middle', horizontal: 'center' }

      });


    }

    return workSheet;
  }

  cWorksheetCuentasDistribuidores(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4


    workSheet.columns = [
      { header: this.configService.etiquetas.Cuentas.NroCliente, key: 'nroCliente', width: 25 },
      { header: this.configService.etiquetas.Cuentas.Nombre, key: 'nombreCliente', width: 35 },
      { header: this.configService.etiquetas.Cuentas.NroClientePartner, key: 'nroClientePartner', width: 25 },
      { header: "Nombre distribuidor", key: 'nombre', width: 35 },
      { header: this.configService.etiquetas.Cuentas.Ciudad, key: 'ciudad', width: 25 },
      { header: this.configService.etiquetas.Cuentas.CalleNro, key: 'calleNro', width: 35 },
      { header: this.configService.etiquetas.Cuentas.FuncionPartner, key: 'funcionPartner', width: 20 },
    ];
    workSheet.autoFilter = 'A1:G1';


    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    return workSheet;
  }

  cDataWorkSheetCuentasDistribuidores(cuentasDistribuidores: CuentaDistribuidor[], workSheet: any) {

    if (cuentasDistribuidores.length) {
      cuentasDistribuidores.forEach(c => {
        let row = workSheet.addRow(
          {
            nroCliente: c.nroClienteCuenta,
            nombreCliente: c.nombreCliente,
            nombre: c.nombre,
            nroClientePartner: c.nroClienteDistribuidor,
            ciudad: c.ciudad,
            calleNro: c.calleNro,
            funcionPartner: c.funcionPartner

          }
        )
        let ciudad = row.getCell('ciudad');
        ciudad.alignment = { wrapText: true }

        let nombreCliente = row.getCell('nombreCliente');
        ciudad.alignment = { wrapText: true }

        let nombre = row.getCell('nombre');
        ciudad.alignment = { wrapText: true }

        let calleNro = row.getCell('calleNro');
        calleNro.alignment = { wrapText: true }

      });


    }

    return workSheet;
  }

  cWorksheetDirecciones(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4


    workSheet.columns = [
      { header: this.configService.etiquetas.IdPais, key: 'idPais', width: 25 },
      { header: this.configService.etiquetas.Cuentas.NroCliente, key: 'nroCliente', width: 35 },
      { header: this.configService.etiquetas.Cuentas.Nombre, key: 'nombreCliente', width: 35 },
      { header: this.configService.etiquetas.Cuentas.NroClientePartner, key: 'nroClientePartner', width: 25 },
      { header: "Nombre dirección", key: 'nombre', width: 35 },
      { header: this.configService.etiquetas.Cuentas.Provincia, key: 'provincia', width: 35 },
      { header: this.configService.etiquetas.Cuentas.Ciudad, key: 'ciudad', width: 25 },
      { header: this.configService.etiquetas.Cuentas.CalleNro, key: 'calleNro', width: 35 },
      { header: this.configService.etiquetas.Cuentas.CodigoPostal, key: 'codigoPostal', width: 25 },
      { header: this.configService.etiquetas.Cuentas.DireccionEnvio, key: 'direccionEnvio', width: 15 },
      { header: "Dir. facturación", key: 'direccionFacturacion', width: 15 },
      { header: this.configService.etiquetas.Cuentas.FuncionPartner, key: 'funcionPartner', width: 20 },
    ];
    workSheet.autoFilter = 'A1:L1';


    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    return workSheet;
  }

  cDataWorkSheetDirecciones(direcciones: Direccion[], workSheet: any) {

    if (direcciones.length) {
      direcciones.forEach(c => {
        let row = workSheet.addRow(
          {
            idPais: c.idPais,
            nroCliente: c.nroCliente,
            nombreCliente: c.nombreCliente,
            nroClientePartner: c.nroClientePartner,
            nombre: c.nombre,
            provincia: c.provincia,
            ciudad: c.ciudad,
            calleNro: c.calleNro,
            codigoPostal: c.codigoPostal != null ? c.codigoPostal : "",
            direccionEnvio: c.direccionEnvio ? "Si" : "No",
            direccionFacturacion: c.direccionFacturacion ? "Si" : "No",
            funcionPartner: c.funcionPartner

          }
        )
        let ciudad = row.getCell('ciudad');
        ciudad.alignment = { wrapText: true }

        let nombreCliente = row.getCell('nombreCliente');
        ciudad.alignment = { wrapText: true }
        let nombre = row.getCell('nombre');
        ciudad.alignment = { wrapText: true }

        let calleNro = row.getCell('calleNro');
        calleNro.alignment = { wrapText: true }

      });


    }

    return workSheet;
  }


  cPlantillaAltaMasivaCuotasDistribuidores() {

    let workbook = new Workbook();
    workbook.creator = ' ';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.CuotasDistribuidores.ExcelAltaMasiva.P1);

    //Productos

    workSheet1.pageSetup.paperSize = 9; //A4
    workSheet1.columns = [
      { header: this.configService.etiquetas.CuotasDistribuidores.ExcelAltaMasiva.Headers.NroClienteDistribuidor, key: 'nroClienteDistribuidor', width: 30 },
      { header: this.configService.etiquetas.CuotasDistribuidores.ExcelAltaMasiva.Headers.IdSucursal, key: 'idSucursal', width: 30 },
      { header: this.configService.etiquetas.IdProducto, key: 'idProducto', width: 30 },
      { header: this.configService.etiquetas.Mes, key: 'mes', width: 15 },
      { header: this.configService.etiquetas.Anio, key: 'anio', width: 15 },
      { header: this.configService.etiquetas.CuotaCant, key: 'cuotaCant', width: 25 }
    ];


    let headerRow = workSheet1.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })


    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, this.configService.etiquetas.CuotasDistribuidores.ExcelAltaMasiva.NombrePlantilla + ".xlsx");
    })

  }


  cPlantillaAltaMasivaCuotasPlantas() {

    let workbook = new Workbook();
    workbook.creator = ' ';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.CuotasPlantas.ExcelAltaMasiva.P1);

    //Productos

    workSheet1.pageSetup.paperSize = 9; //A4
    workSheet1.columns = [
      { header: this.configService.etiquetas.CuotasPlantas.ExcelAltaMasiva.Headers.IdPlanta, key: 'idPlanta', width: 30 },
      { header: this.configService.etiquetas.CuotasPlantas.ExcelAltaMasiva.Headers.IdUbicacionAlmacenamiento, key: 'idUbicacionAlmacenamiento', width: 35 },
      { header: this.configService.etiquetas.IdProducto, key: 'idProducto', width: 30 },
      { header: this.configService.etiquetas.Mes, key: 'mes', width: 15 },
      { header: this.configService.etiquetas.Anio, key: 'anio', width: 15 },
      { header: this.configService.etiquetas.CuotaCant, key: 'cuotaCant', width: 25 }
    ];


    let headerRow = workSheet1.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    workSheet1.getColumn('idUbicacionAlmacenamiento').eachCell(function (cell, rowNumber) {
      cell.style.numberFormat = { type: 'text' };
    });
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, this.configService.etiquetas.CuotasPlantas.ExcelAltaMasiva.NombrePlantilla + ".xlsx");
    })

  }

  // Reporte Pedidos 

  cExcelReportePedidos(pedidos: PedidoCabecera[]) {
    let pcs: PedidoCabecera[] = [];
    pcs = Object.assign([], pedidos);
    pcs = pcs.sort((a, b) => a.nroPedido.toString().localeCompare(b.nroPedido.toString()));
    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.ReportesPedidos.Excel.P1);

    workSheet1 = this.cWorksheetReportePedidos(workSheet1);

    workSheet1 = this.cDataWorkSheetReportePedidos(pcs, workSheet1);

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, this.configService.etiquetas.ReportesPedidos.NombreExcelReporte + '.xlsx');
    })
  }
  cWorksheetReportePedidos(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4


    workSheet.columns = [
      { header: this.configService.etiquetas.Compania, key: 'idCompania', width: 20 },
      { header: this.configService.etiquetas.SalesOrg, key: 'idSalesOrg', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.TipoOrden, key: 'tipoOrden', width: 30 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.NroPedido, key: 'nroPedido', width: 20 },
      { header: this.configService.etiquetas.FechaCreacion, key: 'fechaCreacion', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.NroOrdenSAP, key: 'nroOrdenSap', width: 20 },
      { header: this.configService.etiquetas.Division, key: 'idDivision', width: 10 },
      { header: this.configService.etiquetas.NroCliente, key: 'nroCliente', width: 20 },
      { header: this.configService.etiquetas.NombreCliente, key: 'nombreCliente', width: 40 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.GrupoCliente, key: 'idGrupoCliente', width: 20 },
      { header: this.configService.etiquetas.CuitCliente, key: 'cuit', width: 20 },
      { header: this.configService.etiquetas.NombreDistribuidor, key: 'nombreDistribuidor', width: 30 },
      { header: this.configService.etiquetas.EnviadoDistribuidor, key: 'enviadoDistribuidor', width: 30 },
      { header: this.configService.etiquetas.Region, key: 'region', width: 20 },
      { header: this.configService.etiquetas.IdZonaVendedor, key: 'nombreVendedor', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.ListaPrecios, key: 'tipoListaPrecios', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.TerminoPago, key: 'terminoPago', width: 30 },
      { header: this.configService.etiquetas.Glosa, key: 'glosa', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.MotivoRetencion, key: 'motivoRetencion', width: 30 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.MotivoDevolucion, key: 'motivoDevolucion', width: 30 },
      { header: this.configService.etiquetas.Estado, key: 'estado', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidos.Excel.Headers.FechaEstado, key: 'fechaEstado', width: 20 },
      { header: this.configService.etiquetas.Comentario, key: 'comentario', width: 30 },
      { header: this.configService.etiquetas.IdMoneda, key: 'idMoneda', width: 10 },
      { header: this.configService.etiquetas.TotalOriginal, key: 'totalOriginal', width: 20 },
      { header: this.configService.etiquetas.Total, key: 'total', width: 20 },
      { header: this.configService.etiquetas.TotalLocal, key: 'totalLocal', width: 20 },
    ];

    workSheet.getColumn('fechaCreacion').numFmt = 'dd/mm/yyyy HH:mm'
    workSheet.getColumn('fechaEstado').numFmt = 'dd/mm/yyyy HH:mm'

    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    return workSheet;
  }
  cDataWorkSheetReportePedidos(pedidos: PedidoCabecera[], workSheet: any) {

    if (pedidos.length) {
      pedidos.forEach(c => {
        const fechaCreacion = new Date(c.fechaCreacion);

        const fechaEstado = c.fechaEstado ? new Date(c.fechaEstado) : "";

        const totalLocal = Math.round(c.totalLocal);
        let row = workSheet.addRow(
          {
            idCompania: c.idCompania,
            idSalesOrg: c.idSalesOrg,
            tipoOrden: c.tipoOrden,
            nroPedido: c.nroPedido,
            fechaCreacion: fechaCreacion,
            nroOrdenSap: c.nroOrdenSap,
            idDivision: c.idDivision,
            nroCliente: c.nroCliente,
            nombreCliente: c.nombreCliente,
            idGrupoCliente: c.idGrupoCliente,
            cuit: c.cuit,
            nombreDistribuidor: c.nombreDistribuidor,
            enviadoDistribuidor: c.enviadoDistribuidor ? 'Si' : 'No',
            region: c.region,
            nombreVendedor: c.nombreVendedor,
            tipoListaPrecios: c.tipoListaPrecios,
            terminoPago: c.terminoPago,
            glosa: c.glosa,
            motivoRetencion: c.motivoRetencion,
            motivoDevolucion: c.motivoDevolucion,
            estado: c.estado,
            fechaEstado: fechaEstado,
            comentario: c.comentario,
            idMoneda: c.idMoneda,
            totalOriginal: c.idMoneda === "CLP" ? totalLocal : c.total,
            total: c.total,
            totalLocal: totalLocal
          }
        )

      });
    }

    return workSheet;
  }
  ///Reporte Pedidos Detallados


  cExcelReportePedidosDetallados(pedidos: PedidoDetallado[]) {
    let ps: PedidoDetallado[] = [];
    ps = Object.assign([], pedidos);
    //ps = ps.sort((a, b) => a.nroPedido.toString().localeCompare(b.nroPedido.toString()));
    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.ReportesPedidosDetallados.Excel.P1);

    workSheet1 = this.cWorksheetReportePedidosDetallados(workSheet1);

    workSheet1 = this.cDataWorkSheetReportePedidosDetallados(ps, workSheet1);

    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, this.configService.etiquetas.ReportesPedidosDetallados.NombreExcelReporte + '.xlsx');
    })
  }
  cWorksheetReportePedidosDetallados(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4


    workSheet.columns = [
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.TipoOrden, key: 'tipoOrden', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.NroPedido, key: 'nroPedido', width: 20 },
      { header: this.configService.etiquetas.FechaCreacion, key: 'fechaCreacion', width: 20 },
      { header: this.configService.etiquetas.Estado, key: 'estado', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.FechaEstado, key: 'fechaEstado', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.NroOrdenSAP, key: 'nroOrdenSap', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.MotivoRetencion, key: 'motivoRetencion', width: 30 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.MotivoDevolucion, key: 'motivoDevolucion', width: 30 },
      { header: this.configService.etiquetas.TipoNC, key: 'tipoNC', width: 20 },
      { header: this.configService.etiquetas.Division, key: 'idDivision', width: 10 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.NroComprobante, key: 'nroComprobante', width: 20 },
      { header: this.configService.etiquetas.NroRemito, key: 'nroRemito', width: 30 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.NroCliente, key: 'nroCliente', width: 20 },
      { header: this.configService.etiquetas.NombreCliente, key: 'nombreCliente', width: 40 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.GrupoCliente, key: 'idGrupoCliente', width: 20 },
      { header: this.configService.etiquetas.CuitCliente, key: 'cuit', width: 20 },
      { header: this.configService.etiquetas.NombreDistribuidor, key: 'nombreDistribuidor', width: 30 },
      { header: this.configService.etiquetas.EnviadoDistribuidor, key: 'enviadoDistribuidor', width: 30 },
      { header: this.configService.etiquetas.Region, key: 'region', width: 20 },
      { header: this.configService.etiquetas.IdZonaVendedor, key: 'nombreVendedor', width: 20 },
      { header: this.configService.etiquetas.TipoListaPrecios, key: 'tipoListaPrecios', width: 30 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.TerminoPago, key: 'terminoPago', width: 30 },
      { header: this.configService.etiquetas.NroLinea, key: 'nroLinea', width: 10 },
      { header: this.configService.etiquetas.IdProducto, key: 'idProducto', width: 20 },
      { header: this.configService.etiquetas.Producto, key: 'producto', width: 30 },
      { header: this.configService.etiquetas.Cantidad, key: 'cantidad', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.PrecioLista, key: 'precioUnitarioLista', width: 20 },
      { header: this.configService.etiquetas.Recargo, key: 'recargo', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.TotalDescuento, key: 'totalDescuento', width: 20 },
      { header: this.configService.etiquetas.ReportesPedidosDetallados.Excel.Headers.PrecioUnitarioFinal, key: 'precioUnitarioFinal', width: 20 },
      { header: this.configService.etiquetas.IdMoneda, key: 'idMoneda', width: 10 },
      { header: this.configService.etiquetas.Total, key: 'total', width: 15 },
      { header: this.configService.etiquetas.TotalLocal, key: 'totalLocal', width: 15 },
    ];

    workSheet.getColumn('fechaCreacion').numFmt = 'dd/mm/yyyy HH:mm'
    workSheet.getColumn('fechaEstado').numFmt = 'dd/mm/yyyy HH:mm'

    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })
    return workSheet;
  }
  cDataWorkSheetReportePedidosDetallados(pedidos: PedidoDetallado[], workSheet: any) {

    if (pedidos.length) {
      pedidos.forEach(c => {
        const fechaCreacion = new Date(c.fechaCreacion);

        const fechaEstado = c.fechaEstado ? new Date(c.fechaEstado) : "";

        let row = workSheet.addRow(
          {
            tipoOrden: c.tipoOrden,
            nroPedido: c.nroPedido,
            fechaCreacion: fechaCreacion,
            estado: c.estado,
            fechaEstado: fechaEstado,
            nroOrdenSap: c.nroOrdenSAP,
            motivoRetencion: c.motivoRetencion,
            motivoDevolucion: c.motivoDevolucion,
            tipoNC: c.tipoNC,
            idDivision: c.idDivision,
            nroComprobante: c.nroComprobante,
            nroCliente: c.nroCliente,
            nombreCliente: c.nombreCliente,
            idGrupoCliente: c.idGrupoCliente,
            cuit: c.cuit,
            nombreDistribuidor: c.nombreDistribuidor,
            enviadoDistribuidor: c.enviadoDistribuidor ? 'Si' : 'No',
            region: c.region,
            nombreVendedor: c.nombreVendedor,
            tipoListaPrecios: c.tipoListaPrecios,
            terminoPago: c.terminoPago,
            nroLinea: c.nroLinea,
            idProducto: c.idProducto,
            producto: c.producto,
            cantidad: c.cantidad,
            precioUnitarioLista: c.precioUnitarioLista,
            recargo: c.recargo,
            totalDescuento: c.totalDescuento,
            precioUnitarioFinal: c.precioUnitarioFinal,
            idMoneda: c.idMoneda,
            total: c.total,
            totalLocal: Math.round(c.totalLocal)
          }
        )

      });
    }

    return workSheet;
  }

  //INVENTARIOS

  cExcelReporteDistribuidoresXCantidadDisponible(reporte: StockDistribuidores[]) {

    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.P1);
    workSheet1 = this.cWorksheetReporteDistribuidoresXCantidadDisponible(workSheet1);
    workSheet1 = this.cDataWorkSheetReporteDistribuidoresXCantidadDisponible(reporte, workSheet1);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, "Inventario Distribuidores" + '.xlsx');
    })

  }
  cWorksheetReporteDistribuidoresXCantidadDisponible(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4

    workSheet.autoFilter = 'A1:J1';
    workSheet.columns = [
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.NombreDistribuidor, key: 'nombreDistribuidor', width: 30 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.IdSucursal, key: 'idSucursal', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.Ciudad, key: 'ciudad', width: 30 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.CalleNro, key: 'calleNro', width: 40 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.IdProducto, key: 'idProducto', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.Producto, key: 'producto', width: 35 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.StockNoRestringido, key: 'stockNoRestringido', width: 25 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.CantidadPedidos, key: 'cantidadPedidos', width: 25 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.CantidadDisponibleVenta, key: 'cantidadDisponibleVenta', width: 30 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXCantidadDisponible.Headers.Estado, key: 'estado', width: 20 },

    ];

    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })

    return workSheet;
  }
  cDataWorkSheetReporteDistribuidoresXCantidadDisponible(reporte: StockDistribuidores[], workSheet: any) {
    if (reporte.length) {
      reporte.forEach(s => {

        let row = workSheet.addRow(
          {
            nombreDistribuidor: s.nombreDistribuidor,
            idSucursal: s.idSucursal,
            ciudad: s.ciudad,
            calleNro: s.calleNro,
            idProducto: s.idProducto,
            producto: s.producto,
            stockNoRestringido: s.stockNoRestringido,
            cantidadPedidos: s.cantidadPedidos,
            cantidadDisponibleVenta: s.cantidadDisponibleVenta,
            estado: s.estado

          }
        )


      });
    }
    return workSheet;
  }

  cExcelReporteDistribuidoresXLotes(reporte: StockDistribuidoresLotes[]) {

    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.P1);
    workSheet1 = this.cWorksheetReporteDistribuidoresXLotes(workSheet1);
    workSheet1 = this.cDataWorkSheetReporteDistribuidoresXLotes(reporte, workSheet1);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, "Inventario Distribuidores Lotes" + '.xlsx');
    })

  }
  cWorksheetReporteDistribuidoresXLotes(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4

    workSheet.autoFilter = 'A1:J1';
    workSheet.columns = [
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.NombreDistribuidor, key: 'nombreDistribuidor', width: 30 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.IdSucursal, key: 'idSucursal', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.Ciudad, key: 'ciudad', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.CalleNro, key: 'calleNro', width: 30 },
            { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.Lote, key: 'lote', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.IdProducto, key: 'idProducto', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.Producto, key: 'producto', width: 35 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.CantidadSAP, key: 'cantidadSAP', width: 25 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.CantidadDisponible, key: 'cantidadDisponible', width: 25 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.CantidadTransito, key: 'cantidadTransito', width: 30 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.CantidadTransitoDevolucion, key: 'cantidadTransitoDevolucion', width: 30 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.Estado, key: 'estado', width: 20 },
      { header: this.configService.etiquetas.Inventarios.Excel.DistribuidoresXLote.Headers.FechaVencimiento, key: 'fechaVencimiento', width: 20 },

    ];
 workSheet.getColumn('fechaVencimiento').numFmt = 'dd/mm/yyyy'
    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })

    return workSheet;
  }
  cDataWorkSheetReporteDistribuidoresXLotes(reporte: StockDistribuidoresLotes[], workSheet: any) {
    if (reporte.length) {
      reporte.forEach(s => {
const fechaVencimiento = new Date(s.fechaVencimiento);
        fechaVencimiento.setHours(0, 0, 0, 0);
        let row = workSheet.addRow(
          {
            nombreDistribuidor: s.nombreDistribuidor,
            idSucursal: s.idSucursal,
            ciudad: s.ciudad,
            calleNro: s.calleNro,
            lote: s.lote,
            idProducto: s.idProducto,
            producto: s.producto,
            cantidadSAP: s.cantidadSAP,
            cantidadDisponible: s.cantidadDisponible,
            cantidadTransito: s.cantidadTransito,
            cantidadTransitoDevolucion: s.cantidadTransitoDevolucion,
            estado: s.estado,
            fechaVencimiento: fechaVencimiento

          }
        )


      });
    }
    return workSheet;
  }

  /// SHIPTO DISTRIBUIDORES

   cExcelShipToDistribuidores(reporte: ShipToDistribuidor[]) {

    let workbook = new Workbook();
    workbook.creator = 'Order2Go';
    let workSheet1 = workbook.addWorksheet(this.configService.etiquetas.ShipToDistribuidores.Excel.P1);
    workSheet1 = this.cWorksheetReporteShipToDistribuidores(workSheet1);
    workSheet1 = this.cDataWorkSheetReporteShipToDistribuidores(reporte, workSheet1);
    workbook.xlsx.writeBuffer().then((data) => {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, "ShipTo Distribuidores" + '.xlsx');
    })

  }
  cWorksheetReporteShipToDistribuidores(workSheet: any) {
    workSheet.pageSetup.margins = {
      left: 0.25, right: 0.25,
      top: 0.75, bottom: 0.75,
      header: 0.76, footer: 0.76
    };
    workSheet.pageSetup.orientation = 'portrait';
    // workSheet.pageSetup.fitToPage = true;
    workSheet.pageSetup.paperSize = 9; //A4

    workSheet.autoFilter = 'A1:J1';

    								

    workSheet.columns = [
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.ShipTo, key: 'shipTo', width: 30 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.Nombre, key: 'nombre', width: 20 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.Ciudad, key: 'ciudad', width: 30 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.CalleNro, key: 'calleNro', width: 40 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.SucDistribuidor, key: 'sucDistribuidor', width: 20 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.Ciudad, key: 'ciudadSuc', width: 35 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.CalleNro, key: 'calleNroSuc', width: 35 },
      { header: this.configService.etiquetas.ShipToDistribuidores.Excel.Headers.Nombre, key: 'nombreSuc', width: 25 },



    ];

    let headerRow = workSheet.getRow(1);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '10384f' },
        bgColor: { argb: '' }
      }
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFF' },
        size: 12
      }
      cell.alignment = { vertical: 'middle', horizontal: 'center' }
    })

    return workSheet;
  }
  cDataWorkSheetReporteShipToDistribuidores(reporte: ShipToDistribuidor[], workSheet: any) {
    if (reporte.length) {
      reporte.forEach(s => {

        let row = workSheet.addRow(
          {
            shipTo: s.shipTo,
            nombre: s.shipToData.nombre,
            ciudad: s.shipToData.ciudad,
            calleNro: s.shipToData.calleNro,
            sucDistribuidor: s.sucDistribuidor,
            nombreSuc: s.sucDistribuidorData.nombre,
            ciudadSuc: s.sucDistribuidorData.ciudad,
            calleNroSuc: s.sucDistribuidorData.calleNro
          }
        )


      });
    }
    return workSheet;
  }

}


